import { ConfigProvider } from 'antd';
import InvestRegionsOkedsModal from './InvestRegionsOkedsModal.jsx';
import InvestRegionModal from './InvestRegionModal.jsx';
import InvestDistrictModal from './InvestDistrictModal.jsx';
import InvestOkedsModal from './InvestOkedsModal.jsx';
import InvestSubOkedModal from './InvestSubOkedModal.jsx';

function InvestProjectsModals() {
  return (
    <ConfigProvider componentSize="small">
      <InvestRegionsOkedsModal />
      <InvestRegionModal />
      <InvestDistrictModal />
      <InvestOkedsModal />
      <InvestSubOkedModal />
    </ConfigProvider>
  );
}

export default InvestProjectsModals;
